export const ERRORS = Object.freeze({
    DUPLICATE_NAME: 1,
    DUPLICATE_NAME_IN_UPLOAD: 2,
    DUPLICATE_SETTINGS: 3,
    DUPLICATE_SETTINGS_IN_UPLOAD: 4
});
